module.exports = __webpack_public_path__ + "img/paper-plane-solid.21726dce.svg";